/**
 * 从 Cookie 中获取指定字段的值
 * @param name Cookie 名称
 */
export function getCookieValue(name: string): string | null {
    try {
        const encodedName = encodeURIComponent(name) + '='
        const cookiesArray = document.cookie.split(';')

        for (let i = 0; i < cookiesArray.length; i++) {
            const cookie = cookiesArray[i].trim()
            if (cookie.indexOf(encodedName) === 0) {
                return decodeURIComponent(cookie.substring(encodedName.length, cookie.length))
            }
        }

        return null
    } catch (error) {
        console.error('getCookieValue error:', error)
        return null
    }
}

/**
 * 获取 Token
 */
export function getToken(): string {
    try {
        return getCookieValue('B2BToken') || ''
    } catch (error) {
        console.error('getToken error:', error)
        return ''
    }
}

/**
 * 从 localStorage 获取用户信息
 */
export function getUserInfoLocal() {
    try {
        const userInfo = localStorage.getItem('userInfo')
        if (userInfo && userInfo.trim() !== '') {
            const parsed = JSON.parse(userInfo)
            return typeof parsed === 'object' && parsed !== null ? parsed : {}
        }
        return {}
    } catch (error) {
        console.error('Failed to parse userInfo from localStorage:', error)
        return {}
    }
}
